// External Dependencies:
import React from 'react'

// Internal Dependencies:
import PageSections from 'church-theme-library/components/PageSections/_PageSections'

class HomeLayout extends React.Component {
	render() {
		return (
			<div className="main-inner">
				<div className="primary-wrap">
					<div className="primary-content">
						<PageSections { ...this.props } />
					</div>
				</div>
			</div>
		)
	}
}

export default HomeLayout
